/**
 * Adds accessibile dropdown functionality to main navigation.
 *
 * Toggles open/closed on click, as click is better for accessbility.
 * Hover does not show intent and can be problematic for some users.
 */

// Pollyfill for forEach for ie11
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

const menuItems = document.querySelectorAll(
	".main-navigation li.menu-item-has-children"
);
function mainNavigation() {
	// Select all menu items that have a dropdown menu

	// Add event listeners for click and keyboard
	Array.prototype.forEach.call(menuItems, function(el) {
        //el.querySelector("a").addEventListener("click", openDropdownMenu);
		el.querySelector("a").addEventListener("keyup", openDropdownMenuKeyboard);
		el.querySelector("a").addEventListener("keydown", dropdownKeydownHandler);
	});
}
mainNavigation();

// Open dropdown menuu
function openDropdownMenuKeyboard() {

    if (event.keyCode === 32 || event.keyCode === 13) {
        if (this.parentNode.classList.contains("open-menu")) {
            closeDropdownMenu();
        } else {
            event.preventDefault();
            Array.prototype.forEach.call(menuItems, function(el) {
                el.classList.remove("open-menu"); // Closes any open menus
            });
            this.parentNode.classList.add("open-menu");
            this.setAttribute("aria-expanded", "true"); // Indicates to screen readers users that a collapsible area is opened
        }
    }
}

function dropdownKeydownHandler(event) {
	if (event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        this.click();
    }
}

function closeDropdownMenu() { 
    event.preventDefault();
    this.parentNode.classList.remove("open-menu");
    this.setAttribute("aria-expanded", "false"); // Indicates to screen readers that a collapsible area is closed
}

// Get all mobile menu items with dropdowns
const menuItemsMobile = document.querySelectorAll(
	".mobile-navigation li.menu-item-has-children"
);

function mobileMenuDropdown() {
    Array.prototype.forEach.call(menuItemsMobile, function(el) {
        el.querySelector("a").addEventListener("click", function(){
            if (this.parentNode.classList.contains("open-menu")) {
                event.preventDefault();
                this.parentNode.classList.remove("open-menu");
                this.setAttribute("aria-expanded", "false"); // Indicates to screen readers that a collapsible area is closed
            } else {
                event.preventDefault();
                Array.prototype.forEach.call(menuItems, function(el) {
                    el.classList.remove("open-menu"); // Closes any open menus
                });
                this.parentNode.classList.add("open-menu");
                this.setAttribute("aria-expanded", "true"); // Indicates to screen readers users that a collapsible area is opened
            }
        });
    });
}
mobileMenuDropdown();

// Open mobile menu
function openMobileMenu() {
	const menuIcon = document.querySelector(".menu-icon");
	menuIcon.addEventListener("click", function() {
		document.querySelector(".mobile-nav").classList.toggle("open-nav");
        document.querySelector("body").classList.toggle("no-scroll");
        document.querySelector('.mobile-navigation a').focus(); 
	});
}
openMobileMenu();

// Trap tab order when mobile menu is open
function trapTabOrderMobile() {
    let lastMobileItem = document.querySelector(".mobile-nav .locations");
    lastMobileItem.addEventListener('keydown', function() {
        event.preventDefault();
        document.querySelector('.menu-icon a').focus(); 
    })
}
trapTabOrderMobile();

export { mainNavigation, openMobileMenu, trapTabOrderMobile };
